<template>
  <el-upload
    drag
    :class="`ly-upload ${admin}`"
    :auto-upload="false"
    :on-change="handleChange"
    :file-list="fileList"
    v-bind="$attrs"
    v-on="$listeners"
    :limit="limit"
    action="''"
    :multiple="true"
    :on-remove="onRemove"
    :before-remove="beRemove"
  >
    <div class="placeholder" v-if="fileList.length === 0">
      {{ $t("messages.attachedFile") }}을 추가해주세요
    </div>
    <el-button size="mini" plain @click="fileBtnClickEvent"
      >파일 첨부 <i class="icon-FileArrowUp"
    /></el-button>
  </el-upload>
</template>

<script>
export default {
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    admin: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 3,
    },
  },
  methods: {
    handleChange(file, fileList) {
      if (fileList != null && fileList.length > 0) {
        let fList = [];
        fList = fileList;
        fileList = [];
        let cnt = 0;
        for (let i=0; i<fList.length; i++) {
          if (fList[i].size > 0) {
            fileList[cnt] = fList[i];
            cnt++;
          }
        }
      }

      this.$emit("handleChange", file, fileList, "add");
    },

    onRemove(file, fileList) {
      console.log("on---", arguments);
      console.log("on file---", file);
      console.log("on fileList---", fileList);
      this.$emit("handleChange", file, fileList, "del");
    },
    
    beRemove() {
      //before remove
      //console.log("before--", arguments);
    },

    fileBtnClickEvent : function () {
      this.$emit("fileBtnClickEvent");
    },
  },
};
</script>

<style lang="scss" scoped>
@charset "utf-8";
.ly-upload {
  position: relative;
  height: 28px;
  ::v-deep {
    .el-upload {
      width: 100%;
      position: absolute;
      top: 0;
      &-list {
        position: absolute;
        top: 0;
        height: 100%;
        // z-index: -1;
        &__item {
          padding: 0 10px;

          &:first-child {
            margin-top: 0;
          }
          &-status-label {
            display: none;
          }
          .el-icon-document {
            display: none;
          }
          &:hover {
            background: transparent;
          }
        }
        &--text {
          max-width: 620px;
          overflow-x: scroll;
          overflow-y: hidden;
          display: flex;
          align-items: baseline;
          &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
            &-thumb {
              width: 3px;
              height: 3px;
              background-color: $--text-disabled;
              border-radius: $--border-radius-base;
            }
          }
        }
        .el-progress {
          width: 98%;
        }
      }
      &__tip {
        position: absolute;
        top: 50%;
        left: 6px;
        color: $--text-placeholder;
        font-size: $--font-size-table-small;
        transform: translateY(-50%);
      }
      .el-button--mini {
        position: absolute;
        top: 0;
        right: 0;
        height: 26px;
        line-height: 26px;
        padding: 0 15px;
        border-color: $--color-button-upload;
        color: $--color-button-upload;
        width: 90px;
        padding: 0;
        font: {
          size: $--font-size-small;
          weight: $--font-weight-Medium;
        }
      }
      &-dragger {
        position: absolute;
        left: 0;
        width: 100%;
        border: 0;
        height: 28px;
        background: transparent;
        border-radius: 0;
        &::before {
          display: block;
          position: absolute;
          width: calc(100% - 100px);
          left: 0;
          right: 0;
          height: 26px;
          border: 1px solid $--color-light-gray {
            radius: 4px;
          }
          background: transparent;
          content: "";
        }
      }
    }
  }
  .placeholder {
    display: block;
    position: absolute;
    left: 10px;
    font-size: $--font-size-small;
    color: $--text-placeholder;
    line-height: 26px;
  }
  &.admin {
    height: 38px;
    ::v-deep {
      .el-upload {
        &-dragger {
          height: 36px;
          &::before {
            height: 34px;
          }
        }
      }
      .el-button--mini {
        height: 36px;
      }
    }
  }
}
</style>
